import React, { useState } from 'react';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { required } from 'redux-form-validators';

import { FormMessageHOC } from 'common';
import { ReduxSelectField, DefaultButton, Checkbox } from 'common/components';
import ChangeStatusButtonWarning from '../ChangeStatusButtonWarning';
import { changePaymentStatus } from '../../_redux';

import { staticStyles } from './style';

const ChangePaymentStatusForm = ({
  handleSubmit,
  statuses,
  requestId,
  type,
  dispatch,
  invalid,
  submitting,
  error,
  closeModal,
}) => {
  const submit = handleSubmit(values => changePaymentStatus({ id: requestId, type, ...values }, dispatch));

  const [isAgreementChecked, setIsAgreementChecked] = useState(false);

  const handleAgreementToggle = () => {
    setIsAgreementChecked(isChecked => !isChecked);
  };

  return (
    <form className="ChangePaymentStatusForm" onSubmit={submit}>
      <ChangeStatusButtonWarning />
      <div className="ChangePaymentStatusForm__fieldWrapper">
        <Field
          component={ReduxSelectField}
          name="status"
          textId="justStatus"
          options={statuses}
          validate={[required()]}
          disabled={submitting}
        />
        <DefaultButton
          className="ChangePaymentStatusForm__submit-btn"
          textId="boChangeStatus"
          type="submit"
          butColor="warning"
          disabled={invalid || submitting || !isAgreementChecked}
          loading={submitting}
          filled
        />
      </div>
      <div className="ChangePaymentStatusForm__checkbox-wrapper">
        <Checkbox
          checked={isAgreementChecked}
          onClick={handleAgreementToggle}
          textId="boChangeStatusWarningAgreements"
        />
      </div>

      {error && <strong className="formError">{error}</strong>}

      <DefaultButton className="ChangePaymentStatusForm__close-btn" textId="justClose" onClick={closeModal} />
      <style jsx>{staticStyles}</style>
    </form>
  );
};

ChangePaymentStatusForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  requestId: PropTypes.number.isRequired,
  statuses: PropTypes.array,
  error: PropTypes.string,
};

ChangePaymentStatusForm.defaultProps = {
  statuses: [],
  error: '',
};

export default compose(
  FormMessageHOC,
  reduxForm({
    form: 'ChangePaymentStatusForm',
    onSubmitSuccess(result, dispatch, props) {
      props.showFormSuccessMessage(props.successMessageId);
      props.closeModal();
    },
  })
)(ChangePaymentStatusForm);
